import { FilterChip, QuickFiltersBox } from './styles';

export type QuickFilterKey =
  | 'overdue'
  | 'near_deadline'
  | 'no_inspector'
  | 'scheduled_today'
  | 'rejected_by_bank';

interface QuickFilterOption {
  key: QuickFilterKey;
  label: string;
}

const OPTIONS: QuickFilterOption[] = [
  { key: 'overdue', label: 'atrasadas' },
  { key: 'near_deadline', label: 'próximas do prazo' },
  { key: 'scheduled_today', label: 'agendadas hoje' },
  { key: 'no_inspector', label: 'sem vistoriador' },
  { key: 'rejected_by_bank', label: 'rejeitadas pelo banco' },
];

interface QuickFiltersProps {
  active: QuickFilterKey | null;
  onChange: (key: QuickFilterKey | null) => void;
  counters?: Partial<Record<QuickFilterKey, number>>;
}

export function QuickFilters({
  active,
  onChange,
  counters,
}: QuickFiltersProps): JSX.Element {
  return (
    <QuickFiltersBox>
      {OPTIONS.map((option) => {
        const isActive = active === option.key;
        const count = counters?.[option.key];
        const label =
          count !== undefined ? `${option.label} (${count})` : option.label;
        return (
          <FilterChip
            key={option.key}
            label={label}
            color={isActive ? 'primary' : 'default'}
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onChange(isActive ? null : option.key)}
          />
        );
      })}
    </QuickFiltersBox>
  );
}
